import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function InsertDeleteRow({ action, variables, setOpenVariable, showAlert }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'insertRow');
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.INSERT-DELETE-ROW.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) {
            action.fields.tab = { value: 'insertRow' };
        } else {
            setTab(action.fields.tab.value);
        }
        if (!action.fields.insertRow) {
            action.fields.insertRow = { value: '', isRequired: true };
        }
    }, [action]);
    // Handle tab change
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value };
        if (value === 'insertRow') {
            if (action.fields.deleteRows) {
                action.fields.deleteRows.isRequired = false;
            }
            if (action.fields.insertRow) {
                action.fields.insertRow.isRequired = true;
            }
        } else {
            if (action.fields.insertRow) {
                action.fields.insertRow.isRequired = false;
            }
            if (action.fields.deleteRows) {
                action.fields.deleteRows.isRequired = true;
            } else {
                if (!action.fields.deleteRows) {
                    action.fields.deleteRows = { value: '', isRequired: true };
                }
            }
        }
        setTab(value);
    };
    return (
        <div>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element condition-tabs">
                <button className={tab === 'insertRow' ? 'condition-active' : ''}
                    value="insertRow" onClick={handleClick}>
                    {t(label + 'INSERT')}
                </button>
                <button className={tab === 'deleteRow' ? 'condition-active' : ''}
                    value="deleteRow" onClick={handleClick}>
                    {t(label + 'DELETE')}
                </button>
            </div>
            {tab === 'deleteRow' ?
                <div className="form-element">
                    <TextInput action={action} inputName="deleteRows" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired displayName={t(label + 'DELETE')} fieldType='string-rows' />
                    <em className="form-element-eg">{t(label + 'DELETE-EG')}</em>
                </div> :
                <div className="form-element">
                    <TextInput action={action} inputName="insertRow" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired displayName={t(label + 'INSERT')} fieldType='string-rows' />
                    <em className="form-element-eg">{t(label + 'INSERT-EG')}</em>
                </div>
            }
        </div>
    );
}
export default InsertDeleteRow;